(() => {
  function watchRail(rail) {
    const header = document.querySelector('header.header');
    const headerBox = header && (header.closest('.shopify-section') || header);
    const sentinel = document.createElement('div');
    sentinel.className = 'recipe-hub__rail-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    rail.parentNode.insertBefore(sentinel, rail);

    let top = 0;
    const measure = () => {
      top = headerBox ? Math.round(headerBox.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--recipe-rail-top', top + 'px');
    };
    const update = () => rail.classList.toggle('is-stuck', sentinel.getBoundingClientRect().top < top);

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => { measure(); update(); });
    measure();
    update();
  }

  function init(nav) {
    if (nav.dataset.ready) return;
    nav.dataset.ready = 'true';

    const section = nav.closest('.recipe-hub');
    const grid = section && section.querySelector('.recipe-hub__grid');
    const buttons = [...nav.querySelectorAll('[data-cat]')];
    if (!grid || !buttons.length) return;

    const rail = nav.closest('.recipe-hub__filters');
    if (rail) watchRail(rail);

    const tiles = [...grid.querySelectorAll('.recipe-tile')];
    const matches = (tile, cat) => cat === 'all' || (tile.dataset.tags || '').split(' ').includes(cat);

    const setCounts = () => {
      buttons.forEach(button => {
        const out = button.querySelector('[data-recipe-count]');
        if (!out) return;
        out.textContent = tiles.filter(tile => matches(tile, button.dataset.cat)).length;
      });
    };

    const apply = cat => {
      tiles.forEach(tile => { tile.hidden = !matches(tile, cat); });
      buttons.forEach(button => button.toggleAttribute('aria-current', button.dataset.cat === cat));
    };

    setCounts();
    buttons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        apply(button.dataset.cat);
      });
    });
  }

  const run = () => document.querySelectorAll('[data-recipe-categories]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
